import {
    NUMBER,
    STRING,
} from './lex.js';

export const LIST = "LIST"

const FC_Error = Error
export const FC_String = (s) => ({type: STRING, body: s})
export const FC_Number = (n, d) => ({type: NUMBER, numerator: n, denominator: d})

export const FC_List = (js_array) => ({type: LIST, value: js_array})

export const nativeMath = {
    add: (x, y) => FC_Number(x.numerator * y.denominator + y.numerator * x.denominator, x.denominator * y.denominator),
    subtract: (a, b) => FC_Number((a.numerator * b.denominator) - (b.numerator * a.denominator), a.denominator * b.denominator ),
    multiply: (a, b) => FC_Number((a.numerator * b.numerator), (a.denominator * b.denominator) ),
    divide: (a, b) => FC_Number((a.numerator * b.denominator), (a.denominator * b.numerator) ),
    modulo: (a, b) => {
        if (a.denominator !== 1) { throw new FC_Error(`mod not implemented for rationals with non-1 denominators`) }
        if (b.denominator !== 1) { throw new FC_Error(`mod not implemented for rationals with non-1 denominators`) }

        return FC_Number((a.numerator% b.numerator), 1)
    },
    exponent: (a, b) => {
        if (b.denominator !== 1) { throw new FC_Error(`power not implemented for rationals with non-1 denominators`) }
        return FC_Number( (Math.pow(a.numerator, b.numerator)),(a.denominator) )
    },

    double: (x) => FC_Number(x.numerator * 2, x.denominator ),
    to_float: (x) => FC_String(`${x.numerator / x.denominator}`),
}

export const nativeString = {
    append: (original, added) => FC_String(`${original.body}${added.body}`),
    prepend: (original, added) => FC_String(`${added.body}${original.body}`),
    upcase: (original) => FC_String(original.body.toUpperCase()),
    downcase: (original) => FC_String(original.body.toLowerCase()),
    twice: (original) => FC_String(`${original.body} ${original.body}`),
    times: (original, count) => {
        if (count.denominator !== 1) { throw new FC_Error(`String.times not implemented for counts with non-1 denominators`) }
        return FC_String(`${new Array(count.numerator).fill(original.body).join('')}`)
    },
}

export const nativeList = {
    empty: () => (FC_List([])),
    append: (list, item) => (FC_List([...list.value, item])),
    prepend: (list, item) => (FC_List([item, ...list.value])),
    map_double: (list) => {
        const actualList = list.value
        if (actualList.map === undefined) {
            throw new FC_Error(`List.map requires a list as its first argument`)
        }
        // const func = func_lookup(func_name)
        return {
            type: LIST, 
            value: actualList.map((item) => {
                return FC_Number(item.numerator * 2, item.denominator)
            }),
        }
    },
}

export const nativeKernel = {
    identity: (x) => (x),
}